// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessagePageTemplate_wrapper__1rpE8","card":"MessagePageTemplate_card__2Gg9_","legend":"MessagePageTemplate_legend__35bGa"};